/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PutApiV1LocationStatesIdMutationRequest,
  PutApiV1LocationStatesIdMutationResponse,
  PutApiV1LocationStatesIdPathParams,
  PutApiV1LocationStatesId400,
  PutApiV1LocationStatesId401,
  PutApiV1LocationStatesId404,
  PutApiV1LocationStatesId409,
  PutApiV1LocationStatesId500,
} from "../../types/locationStateController/PutApiV1LocationStatesId.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { putApiV1LocationStatesId } from "../../clients/locationStateController/putApiV1LocationStatesId.ts";

export const putApiV1LocationStatesIdMutationKey = () =>
  [{ url: "/api/v1/location/states/:id" }] as const;

export type PutApiV1LocationStatesIdMutationKey = ReturnType<
  typeof putApiV1LocationStatesIdMutationKey
>;

export function putApiV1LocationStatesIdMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PutApiV1LocationStatesIdMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const mutationKey = putApiV1LocationStatesIdMutationKey();
  return mutationOptions<
    PutApiV1LocationStatesIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1LocationStatesId400
      | PutApiV1LocationStatesId401
      | PutApiV1LocationStatesId404
      | PutApiV1LocationStatesId409
      | PutApiV1LocationStatesId500
    >,
    {
      id: PutApiV1LocationStatesIdPathParams["id"];
      data?: PutApiV1LocationStatesIdMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id, data }) => {
      return putApiV1LocationStatesId(id, data, config);
    },
  });
}

/**
 * @description Atualiza a sigla, o nome, a abreviação e o país de um estado. A sigla e o nome devem permanecer únicos. **(Requer Authorization para autenticação)**
 * @summary Atualizar estado (Requer Authorization para autenticação)
 * {@link /api/v1/location/states/:id}
 */
export function usePutApiV1LocationStatesId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PutApiV1LocationStatesIdMutationResponse,
      ResponseErrorConfig<
        | PutApiV1LocationStatesId400
        | PutApiV1LocationStatesId401
        | PutApiV1LocationStatesId404
        | PutApiV1LocationStatesId409
        | PutApiV1LocationStatesId500
      >,
      {
        id: PutApiV1LocationStatesIdPathParams["id"];
        data?: PutApiV1LocationStatesIdMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PutApiV1LocationStatesIdMutationRequest>> & {
      client?: Client;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? putApiV1LocationStatesIdMutationKey();

  const baseOptions = putApiV1LocationStatesIdMutationOptions(
    config,
  ) as UseMutationOptions<
    PutApiV1LocationStatesIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1LocationStatesId400
      | PutApiV1LocationStatesId401
      | PutApiV1LocationStatesId404
      | PutApiV1LocationStatesId409
      | PutApiV1LocationStatesId500
    >,
    {
      id: PutApiV1LocationStatesIdPathParams["id"];
      data?: PutApiV1LocationStatesIdMutationRequest;
    },
    TContext
  >;

  return useMutation<
    PutApiV1LocationStatesIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1LocationStatesId400
      | PutApiV1LocationStatesId401
      | PutApiV1LocationStatesId404
      | PutApiV1LocationStatesId409
      | PutApiV1LocationStatesId500
    >,
    {
      id: PutApiV1LocationStatesIdPathParams["id"];
      data?: PutApiV1LocationStatesIdMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PutApiV1LocationStatesIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1LocationStatesId400
      | PutApiV1LocationStatesId401
      | PutApiV1LocationStatesId404
      | PutApiV1LocationStatesId409
      | PutApiV1LocationStatesId500
    >,
    {
      id: PutApiV1LocationStatesIdPathParams["id"];
      data?: PutApiV1LocationStatesIdMutationRequest;
    },
    TContext
  >;
}
